import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 right-0 p-4 sm:p-6" }
const _hoisted_2 = { class: "ml-4 flex shrink-0 absolute top-4 right-4" }

import VButton from "../Buttons/VButton.vue"

	import {
		clsx,
	} from "clsx"

	import {
		Dialog,
		DialogPanel,
		TransitionChild,
		TransitionRoot,
	} from "@headlessui/vue"

	import {
		ref,
		watch,
	} from "vue"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'VNotification',
  props: {
		className: {
			type: String,
			default: "",
		},
		onClose: {
			type: Function,
			default: () => { return },
		},
		duration: {
			type: Number,
			default: 5000,
		},
		open: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "md",
		},
	},
  setup(__props) {

	const props = __props

	const dialogPanelRef = ref(null)

	const sizes: { [k: string]: string } = {
		xs: "sm:max-w-xs",
		sm: "sm:max-w-sm",
		md: "sm:max-w-md",
		lg: "sm:max-w-lg",
		xl: "sm:max-w-xl",
		"2xl": "sm:max-w-2xl",
		"3xl": "sm:max-w-3xl",
		"4xl": "sm:max-w-4xl",
		"5xl": "sm:max-w-5xl",
	}

	watch(() => props.open, (newValue, oldValue) => {
		if (newValue === true && oldValue == false) {
			setTimeout(() => {
				props.onClose()
			}, props.duration)
		}
	})

return (_ctx: any,_cache: any) => {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: __props.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        className: "z-[99] absolute",
        "initial-focus": dialogPanelRef.value,
        onClose: ($event: any) => (null)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-in-out duration-300",
              "enter-from": "translate-x-full",
              "enter-to": "translate-x-0",
              leave: "ease-in-out duration-300",
              "leave-from": "translate-x-0",
              "leave-to": "translate-x-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogPanel), {
                  ref_key: "dialogPanelRef",
                  ref: dialogPanelRef,
                  class: _normalizeClass(_unref(clsx)(
							__props.className,
							sizes[__props.size],
							'row-start-2 backdrop-blur-md w-full rounded-2xl bg-white/90 p-8 shadow-lg ring-1 ring-zinc-950/10 sm:rounded-2xl sm:p-6 dark:bg-zinc-900 dark:ring-white/10 forced-colors:outline'))
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default"),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(VButton, {
                        plain: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.onClose()))
                      }, {
                        default: _withCtx(() => [
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sr-only" }, "Close", -1)),
                          _createVNode(_component_XMarkIcon, {
                            class: "size-5",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1,
                        __: [1]
                      })
                    ])
                  ]),
                  _: 3
                }, 8, ["class"])
              ]),
              _: 3
            })
          ])
        ]),
        _: 3
      }, 8, ["initial-focus"])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})